import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'eze-dynamic-registration-form',
	templateUrl: './dynamic-registration-form.component.html',
	styleUrls: ['./dynamic-registration-form.component.css'],
})
export class DynamicRegistrationFormComponent implements OnInit {
	constructor(private route: ActivatedRoute) {}

	ngOnInit() {
		const formId = this.route.snapshot.paramMap.get('formId');
		console.log({ formId });
	}
}
